module.exports = __webpack_public_path__ + "img/3.84edf29a.jpg";